import { io } from "socket.io-client";
import config from "./config";

const socket = io(config.SOCKET_API_ENDPOINT, { transports: ["polling"] });
export default socket;
